import React, { ReactElement, useEffect, useCallback } from "react";
import classnames from "classnames";
import { UseSelectGetItemPropsOptions } from "downshift";

interface DropdownItemProps {
  id?: string;
  disabled?: boolean;
  action?: () => void;
  className?: string;
  // below props aren't really optional, but to avoid unnecessary errors it's done like this
  item?: ReactElement;
  index?: number;
  highlighted?: boolean;
  getItemProps?: (options: UseSelectGetItemPropsOptions<ReactElement>) => any;
  onHighlightedChange?: (actionCallback: () => void) => void;
  children?: React.ReactNode;
}

export const LazyLoadDropdownItem = ({
  item,
  id,
  disabled,
  action,
  className,
  index,
  highlighted,
  getItemProps,
  onHighlightedChange,
  children,
}: DropdownItemProps) => {
  const actionCallback = useCallback(() => {
    !disabled && action && action();
  }, [disabled, action]);

  useEffect(() => {
    if (highlighted) {
      onHighlightedChange(actionCallback);
    }
  }, [highlighted, actionCallback, onHighlightedChange]);

  return (
    <li
      className={classnames("dropdown__item", className, {
        "dropdown__item--disabled": disabled,
        "dropdown__item--highlighted": highlighted,
      })}
      {...getItemProps({
        item,
        index,
        disabled: !action || disabled,
      })}
      id={id} // for qa
    >
      {children}
    </li>
  );
};
